import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import { setCurrentScreen, logEvent, getAnalytics } from 'firebase/analytics';

export const useAnalytics = () => {
  // analytics

  const routers = useRouter();

  useEffect(() => {
    const routeHandler = (url: string) => {
      setCurrentScreen(getAnalytics(), url);
      logEvent(getAnalytics(), 'screen_view');
    };
    if (!process.browser) {
      // THIS IS IMPORTANT!!! :Remove Event Listener after un-mount
      return () => {
        routers.events.off('routeChangeComplete', routeHandler);
      };
    }

    if (
      process.env.NODE_ENV === 'production' ||
      //@ts-ignore
      process.env.NODE_ENV === 'preview'
    ) {
      routers.events.on('routeChangeStart', routeHandler);
      //For First Page
      routeHandler(window.location.pathname);
    }
    // THIS IS IMPORTANT!!! :Remove Event Listener after un-mount
    return () => {
      routers.events.off('routeChangeStart', routeHandler);
    };
  }, [routers.events]);
};
export const logAppEvent = (event: string) => {
  if (process.env.NODE_ENV === 'production') {
    logEvent(getAnalytics(), event);
  }
};
